import axios from 'axios';
import qs from 'qs';
import * as utils from '../common/utils';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export function loginUser(username, password){
    return new Promise(function(resolve, reject){
        //http://localhost:8080/api/login
        axios.post('/api/login',qs.stringify({username:username, password:password, login:"1"}))
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                reject(err);
            })

        /*
        if(username == 'admin' && password == 'admin123'){
            return resolve({
                username:'admin',
                type:3
            });
        }
        return reject();
        */
    })

}

export function logoutUser(){
    return new Promise(function(resolve, reject){
        axios.get('/api/login?logout=1')
            .then(response=>{
                resolve()
            })
            .catch(err=>reject(err))
    })
}

export function getUser(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/get-users'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject(err);
            })
    })
}

/* REAL TIME DATA */
export function getRealTimeNoise(){
    return getRealTimeData('noise');
}

export function getRealTimeWeather(){
    return getRealTimeData('weath');
}

export function getRealTimeSpectrum(){
    return getRealTimeData('spect');
}

export function getRealTimeData(type,count){
    let token = getToken();
    return axios.get('/api/get-rt-'+type+'&val='+count+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        //return Promise.reject({message:'errorConnecting', err:err});
    })
    .then(handleApiResponse)

}

/* DATA */
export function getNoise(measurementTime, startTime, stopTime){
    return getData('noise', measurementTime, startTime, stopTime);
}

export function getSpectrum(measurementTime, startTime, stopTime){
    return getData('spect', measurementTime, startTime, stopTime);
}

export function getWeather(measurementTime, startTime, stopTime){
    return getData('weath', measurementTime, startTime, stopTime);
}

export function getData(type, measurementTime, startTime, stopTime){
    //http://89.212.28.252:8888/api/get-noise&measurement=2017-07-26-14&start=2017-07-26 14:10:22&stop=2017-07-26 14:20:00
    var date = getUrlEncodedMeasurementHourFile(measurementTime);
    var startValue = (startTime)? getUrlEncodedDateTime(startTime):undefined;
    var stopValue = (stopTime)? getUrlEncodedDateTime(stopTime):undefined;

    let token = getToken();

    return axios.get(('/api/get-'+type+'&measurement='+date+'&start='+startValue+'&stop='+stopValue).replace(/ /g, '_')+'&time='+Date.now(),  {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)

}

/* Day Data */

export function getDayNoise(measurementTime, startTime, stopTime){

    return getDayData('noise',measurementTime, startTime, stopTime);
}

export function getDayWeather(measurementTime, startTime, stopTime){
    return getDayData('weath',measurementTime, startTime, stopTime);
}

export function getDayData(type, measurementTime, startTime, stopTime){
    var date = getUrlEncodedMeasurementDayFile(measurementTime);
    var startValue = (startTime)? getUrlEncodedDateTime(startTime):undefined;
    var stopValue = (stopTime)? getUrlEncodedDateTime(stopTime):undefined;

    let token = getToken();

    if(type == 'statistics'){
        return axios.get(('/api/get-'+type+'&measurement='+date).replace(/ /g, '_')+'&time='+Date.now(), {headers: {'Token':token}})
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            })
            .then(handleApiResponse)
    }else{
        return axios.get(('/api/get-day-'+type+'&measurement='+date+'&start='+startValue+'&stop='+stopValue).replace(/ /g, '_')+'&time='+Date.now(), {headers: {'Token':token}})
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            })
            .then(handleApiResponse)
    }

}

/* DAYS LIST */
export function getNoiseDays(){
    return getDays('noise');
}

export function getWeatherDays(){
    return getDays('weather');
}

export function getAudioDays(){
    return getDays('audio');
}

export function getMeasurementsDays(){
    return getDays('measurements');
}

export function getDays(type){
    //http://localhost:8080/api/get-days&type=noise
    let token = getToken();
    return axios.get('/api/get-days&type='+type+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
    .then(handleApiResponse)
}

/* DAY HOURS LIST */
export function getNoiseHours(date){
    return getHours('noise', date);
}

export function getWeatherHours(date){
    return getHours('weather', date);
}

export function getAudioHours(date){
    return getHours('audio', date);
}

export function getMeasurementsHours(date){
    return getHours('measurements', date);
}

export function getHours(type, date){
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    let token = getToken();
    return axios.get('/api/get-day-list&day='+dateValue+'&type='+type+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
        .then(handleApiResponse)
}
export function getArchiveHours(type, date){
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    let token = getToken();
    return axios.get('/api/file-list&date='+dateValue+'&type='+type+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
            .then(handleApiResponse)
}

/* AUDIO */
export function getRecDay(date){
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    let token = getToken();
    return axios.get('/api/get-rec-day&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
        .then(handleApiResponse)
}

export function getRecHour(date){
    var dateValue = getUrlEncodedMeasurementHourFile(date);
    let token = getToken();
    return axios.get('/api/get-rec-hour&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
        .then(handleApiResponse)
}

export function getAudioDay(date){
    //api/get-audio-day&date=2017-07-26
    var dateValue = getUrlEncodedMeasurementDayFile(date);
    let token = getToken();
    return axios.get('/api/get-rec-day&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
        .then(handleApiResponse)
}

export function getAudioHour(date){
    var dateValue = getUrlEncodedMeasurementHourFile(date);
    let token = getToken();
    return axios.get('/api/get-audio-hour&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
        .then(handleApiResponse)
}

export function getAudioFile(file){
    return getAudio(file);
}

export function getAudio(dateValue){
    let token = getToken();
    return axios.get('/api/get-audio-day&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
    .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
    })
        .then(handleApiResponse)
}
/* NEW API CALLS*/
export function setWeather(){
    return new Promise(function(resolve,reject){
        let token = getToken();
        axios.get('/api/set-weather'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //return Promise.reject({message:'errorConnecting', err:err})
            })
    })
}

export function getFirmWare(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/firmware'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            })
    });
}

export function setNoise(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/set-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //return Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function restartNoise(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/restart-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function sdFormatNoise(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/sdformat-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //return Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function sdFreeNoise(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/sdfree-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject({message:'errorConnecting', err:err});
            })
    })
}

export function testOptions(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/options-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject({message:'errorConnecting', err:err});
            })
    })
}

export function testEmail(group){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/test-email&group='+group+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject({message:'errorConnecting', err:err});
            })
    })
}

export function ftpTestConn(address,auth,user,pwd){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/ftpTest&address='+address+'&auth='+auth+'&user='+user+'&pwd='+pwd+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject({message:'errorConnecting', err:err});
            })
    })
}

export function rebootSys(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/reboot'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //return Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

/* ----------- */
/* ----------- */
/* ----------- */
/* ----------- */
/* ----------- */

/* VIDEO */
export function getVideoDay(date){
    var dateValue = getUrlEncodedMeasurementDayFile(date);

    return getVideo(dateValue);
}

export function getVideoHour(date){
    var dateValue = getUrlEncodedMeasurementHourFile(date);
        let token = getToken();
        return axios.get('/api/get-rec-hour&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)
}

export function getVideo(dateValue){
        let token = getToken();
        return axios.get('/api/get-rec-day&date='+dateValue+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)
}
/**Download */

export function postFileAction(action, type, data){
    //api/file-action&action=download&data=noise
        let token = getToken();
        return axios.post('/api/file-action&action='+action+'&data='+type+'&time='+Date.now(), JSON.stringify(data), {headers: {'Token':token}})
        .then(data=>{
            return data.data;
        })
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            //return Promise.reject({message:'errorConnecting', err:err});
        })
}

export function getFilesAction(type, data){
    ///api/file-action&&action=download&type="+ this.type +"&files="+ newHour;
        let token = getToken();
        return axios.get('/api/file-action&action=download&type='+type+'&file='+data+'&time='+Date.now(), {headers: {'Token':token}});
}

export function getFileAction(url,method='GET',postData, downloadProgress=()=>{}){
    return new Promise((resolve, reject)=>{
        let token = getToken();

        axios({
            url: url,
            method: method,
            responseType: 'blob', // important
            headers:{
                'Token':token
            },
            data: JSON.stringify(postData),
            onDownloadProgress: downloadProgress
        }).then((response) => {
            if ((response.headers['content-type']).includes("application/json")) {
                resolve();
            } else {
                let filename = response.headers['content-disposition'].split('filename=')[1].replace(/"/g,'');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                resolve();
            }
        });
    })

}

/* STATUS & START/STOP */
export function getStatus(){
        let token = getToken();
        return axios.get('/api/status'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            //return Promise.reject({message:'errorConnecting', err:err});
        })
        .then(handleApiResponse)
}

/*export function startMeasuring(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/start', {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve()
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}

export function stopMeasuring(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axiso.get('/api/stop', {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}*/

export function startNoise(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/start-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}

export function stopNoise(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/stop-noise'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function startAdio(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/start-adio'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}

export function stopAdio(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/stop-adio'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
               // Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function startAll(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/start'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function stopAll(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/stop'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function startWeather(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        return axios.get('/api/start-weath'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    });
}

export function stopWeather(){
    return new Promise(function(resolve,reject){
        let token = getToken();
        return axios.get('/api/stop-weath'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                switch(response.data.error){
                    case 111:
                        return resolve();
                    case 110:
                        return reject();
                }
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //Promise.reject({message:'errorConnecting', err:err});
            })
    })
}

export function getSystemStatus(){
        let token = getToken();
        return axios.get('/api/machine_stats'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }})
            .then(handleApiResponse)
                //return Promise.reject({message:'errorConnecting', where:'/api/machine_stats', err:err});

}

/* SETTINGS */
export function getDefaultLocalSettings(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/default-local'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            })

    });
}


export function getSettings(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/settings&action=get'+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
            })
    });
}

export function saveSettings(settings){
    return new Promise(function(resolve, reject){
        //debugger;
        //if(true){
        //    return resolve();
        //}
        let token = getToken();
        axios.post('/api/settings?action=save'+'&time='+Date.now(), JSON.stringify(settings), {headers: {'Token':token}})
            .then(response=>{
                resolve();
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject(err);
            })
    });

}

export function increaseVolume(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/inc-volume'+'&time='+Date.now(), {headers: {'Token':token}})
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject(err);
            })
    })
}

export function decreaseVolume(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/dec-volume'+'&time='+Date.now(), {headers: {'Token':token}})
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject(err);
            })
    })
}

/*STREAM */
export function startAudioStream(){
        let token = getToken();
        return axios.get('/api/start_audioStream'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)
}

export function stopAudioStream(){
        let token = getToken();
        return axios.get('/api/stop_audioStream'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)
}

export function startAudioRecording(){
        let token = getToken();
        return axios.get('/api/start-audioMan'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)
}

export function stopAudioRecording(){
        let token = getToken();
        return axios.get('/api/stop-audioMan'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
        .then(handleApiResponse)
}


/* VIDEO */
export function formatVideoSD(){
        let token = getToken();
        return axios.get('/api/sdformat-video'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
}

export function setVideo(){
        let token = getToken();
        return axios.get('/api/set-video'+'&time='+Date.now(), {headers: {'Token':token}})
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
}


export function logsList(){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/logs-list'+'&time='+Date.now(), {headers: {'Token':token}})
        .then(response=>{
            resolve(response.data.data);
        })
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
           // reject(err)
        });
    })

}

export function getLogs(type){
    return new Promise(function(resolve, reject){
        let token = getToken();
        axios.get('/api/logs-cont&file='+type+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject(err)
            });
    })
}


export function deleteOnInterval(from, to, values){
    return new Promise(function(resolve, reject){
        from = getUrlEncodedMeasurementDayFile(from);
        to = getUrlEncodedMeasurementDayFile(to);
        let token = getToken();
        axios.get('/api/delete-manual&from='+from+'&to='+to+'&valsel='+values+'&time='+Date.now(), {headers: {'Token':token}})
            .then(response=>{
                resolve(response.data);
            })
            .catch(err=>{
                if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
                //reject(err)
            });
    })
}


/* MARKERS */

export function getMarkersDay(date){
    var dateValue =  getUrlEncodedMeasurementDayFile(date);
    let token = getToken();
    return axios.get('/api/get-markers&from='+dateValue+'&time='+Date.now(), {headers: {'Token': token}})
        .then(handleApiResponse)
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
}

export function getMarkersHour(date){
    var dateValue =  getUrlEncodedMeasurementHourFile(date);
    let token = getToken();
    return axios.get('/api/get-markers&from='+dateValue+'&time='+Date.now(), {headers: {'Token': token}})
        .then(handleApiResponse)
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
}

export function setMarker(data){
    let fromDate = new Date(data.from);

    let marker = {
        ID: data.id,
        Name: data.name,
        Color: data.color,
        Note: data.note,
        Type: data.type?'Toggle':'Single',
        DateTimeStart: getUrlEncodedDateTime(new Date(data.from)),
        DateTimeStop: getUrlEncodedDateTime(new Date(data.to)),
        Notes: data.notes?data.notes:'',
    }
    return axios.post('api/set-markers&action=set-markers'+'&time='+Date.now(), JSON.stringify(marker));
}


export function deleteMarker(data){
    let id = data.id;
    let date = getUrlEncodedMeasurementDayFile(new Date(data.from));

    return axios.get('/api/delete-markers&id='+id+'&date='+date+'&time='+Date.now());
}

export function setMarkerNote(data){
    let date = getUrlEncodedMeasurementDayFile(new Date(data.date));

    return axios.post('api/update-markers'+'&time='+Date.now(), JSON.stringify({
      id: data.id,
      notes:  data.note,
      date: date
    }));
}

export function getDailyNote(date){
  var dateValue =  getUrlEncodedMeasurementDayFile(date);
  let token = getToken();

  return axios.get('/api/get-markers-day&from='+dateValue+'&time='+Date.now(), {headers: {'Token': token}})
        .then(handleApiResponse)
        .catch(err=>{
            if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
        })
}

export function getDefaultMarkers(){
  let token = getToken();
  return axios.get('/api/default-markers'+'&time='+Date.now(),{headers: {'Token': token}})
  .then(handleApiResponse)
  .catch(err=>{
        if (err.request.status == 401){ if (window.location.href.indexOf('/login')==-1) window.location.href = '/login' }
  })
}

function makePostReady( object )
{
    var sentence = "";
    for (var key in object) {
        var sentenceAdd = key + '=' + object[key] + '&';
        sentence = sentence + sentenceAdd;
    }
    //console.log( 'sentence: ' + sentence );
    return sentence;
}

function handleApiResponse(response){
    return new Promise(function(resolve, reject){
        if(response.data){
            if(typeof response.data === 'string' || response.data instanceof String)
                try{response.data = JSON.parse(response.data);}catch(err){}
            //if(Math.random()*10 < 3)
            //    response.data.error = 102;

            switch(response.data.error){
                //TODO- other errors
                case 101: {
                    if(response.data.threshold){
                        var threshold = {name:response.data.thr_header, value:response.data.threshold.split(',')};
                        return resolve({headers:response.data.headers, data:response.data.data, threshold:threshold});
                    }
                    return resolve({headers:response.data.headers, data:response.data.data});
                }
                case 102:{
                    return reject({error:'noData'});
                }
            }
        }
        return reject({message:'errorNoData', err:''});
    });
}

function getUrlEncodedDateTime(date){
    var output = date.getUTCFullYear()+'-'+
        utils.doubleDigit(date.getUTCMonth()+1)+'-'+
        utils.doubleDigit(date.getUTCDate())+' '+
        utils.doubleDigit(date.getUTCHours())+':'+
        utils.doubleDigit(date.getUTCMinutes())+':'+
        utils.doubleDigit(date.getUTCSeconds());
    return output;
}

function getUrlEncodedMeasurementHourFile(date){
    var output = date.getUTCFullYear()+'-'+
                utils.doubleDigit(date.getUTCMonth()+1)+'-'+
                utils.doubleDigit(date.getUTCDate())+'-'+
                utils.doubleDigit(date.getUTCHours());
    return output;
}

function getUrlEncodedMeasurementDayFile(date){

    var output = date.getUTCFullYear()+'-'+
                utils.doubleDigit(date.getUTCMonth()+1)+'-'+
                utils.doubleDigit(date.getUTCDate());
    return output;
}

function getToken(){
    let token = localStorage.getItem('token');
    return token;
}



// WEBPACK FOOTER //
// ./src/api/index.js